import Splide from '@splidejs/splide';

export default class ProductImageViewer {

  constructor() {
    const imageContainerExists = document.getElementsByClassName('splide').length > 0;
    if (imageContainerExists) {
      const splide = new Splide('.splide', {
        rewind: true,
        pagination: false
      }).mount();

      splide.on('move', function () {
        $("#enlarged-image-modal").fadeOut();
      });
    }

    $("#enlarged-image-modal .close, #enlarged-image-modal .done")
      .on("click", () => $("#enlarged-image-modal").fadeOut())

    $(".product-images .image").on("click", (e) => {
      const currentElement = $(e.currentTarget)
      const largeImageUrl = currentElement.data('large-image')
      const imageAltText = $(currentElement).children('img').attr('alt')

      $("#enlarged-product-image").attr('src', largeImageUrl).attr('alt', imageAltText).fadeIn();
      $("#enlarged-image-modal").fadeToggle();
    })
  }
}